var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exit-Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F3F3F3",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#263238"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "40 37 40 47 23 47 23 17 40 17 40 27"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#263238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.545,25.7891 L44.545,25.7891 C44.147,26.1741 44.147,26.7961 44.545,27.1821 L48.506,31.0131 L33.021,31.0131 C32.459,31.0131 32,31.4571 32,32.0001 C32,32.5431 32.459,32.9871 33.021,32.9871 L48.516,32.9871 L44.555,36.8181 C44.157,37.2041 44.157,37.8261 44.555,38.2111 C44.954,38.5971 45.597,38.5971 45.995,38.2111 L51.701,32.6911 C52.099,32.3061 52.099,31.6841 51.701,31.2991 L45.984,25.7891 C45.597,25.4031 44.943,25.4031 44.545,25.7891",
    id: "Fill-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exit-icon.446d1d83.svg";
export { ForwardRef as ReactComponent };